import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-app-flexbox-grid';
import QRCode from 'qrcode.react';
import Payment from '../Payment/Payment';
import Loader from '../Loader/Loader';
import './Address.css';
import { getAddress } from '../../fetch';
import { network } from '../Network';
import Error from '../Error/Error';
import Table from '../Table/Table';
import history from '../history';
import { formatBalance } from '../balances';
import { isNftCheck } from '../../nft';

class Address extends Component {
    constructor(props){
        super(props);
        let data = props.params.data;
        let error = props.params.error;
        if(data == null){
            if(
                typeof window !== "undefined" && 
                window != null && window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.data != null
            ){
                data = window.__INITIAL_STATE__.data;
                window.__INITIAL_STATE__.data = null;
            }
        }
        if(error == null){
            if(
                typeof window !== "undefined" && window != null && 
                window.__INITIAL_STATE__ != null && 
                window.__INITIAL_STATE__.error != null
            ){
                error = window.__INITIAL_STATE__.error;
                window.__INITIAL_STATE__.error = null;
            }
        }
        this.state = {
            id: props.params.id,
            load: data == null && error == null, 
            error: error,
            address: data,
            balances: []
        }
    }

    componentDidMount(){
        if(this.state.address == null && this.state.error == null){
            this.load();
        }
    }

    componentDidUpdate(){
        if(this.state.id !== this.props.params.id){
            this.setState({
                id: this.props.params.id,
                load: true, 
                error: null,
                address: null
            });
            this.load(this.props.params.id);
        }
    }

    load(id){
        if(this.state.load === false){
            this.setState({load: true});
        }
        if(id == null){
            id = this.state.id;
        }
        getAddress(id,(data)=>{
            const getBalance = async () => {
                const balances = [];
                for (const balance of data.data.balances) {
                    balances.push(await this.formatBalance(balance));
                }
                this.setState({load: false, error: data.error, address: data.data, balances});
            };
            getBalance();
        }, network);
    }

    async formatBalance(b){
        let creator = {text:''};
        if(b.asset_issuer != null){
            creator = {text:b.asset_issuer.substring(0,4),callback:()=>{history.push('/address/'+b.asset_issuer)}};
        }
        let asset = {text:'XDB'};
        if(b.asset_code != null){
            asset = {text:b.asset_code};
        }
        return [
            asset,
            {text: formatBalance(b.balance, await isNftCheck(b.asset_issuer, b.asset_code, network))},
            creator
        ];
    }

    render() {
        if(this.state.address != null){
            var address, crypto;
            var payments = [];
            
            address = {
                headers:[{width:"100%"}],
                items:[[{text:this.state.address.account_id}]]
            };

            crypto = { 
                headers:[{width:"25%"},{width:"50%",align:'right'},{width:"25%",align:'right'}],
                items: this.state.balances
            };

            if(this.state.address.txs !== null && this.state.address.txs !== undefined){
                this.state.address.txs.forEach((p,i)=>{
                    payments.push(
                        <Col xs={12} key={"payment" + i} className={i%2 === 1 ? "over" : ""}>
                            <div className="address-payment">
                                <Payment payment={p} currency={this.props.currency}/> 
                            </div>
                        </Col>
                )});
            }
        }
        return ( 
            <Grid fluid className="address">
                {this.state.load && <Loader/>}
                {this.state.address != null &&
                    <Row>
                        <Col xs={12} md={8}>
                            <div className="address-block">
                                <h2 className="address-title">Wallet Address</h2>
                                <div className="mobile address-link">{this.state.address.account_id}</div>
                                <div className="address-block address-qr mobile">
                                    <QRCode value={this.state.address.account_id} size={120} />
                                </div>
                                <div className="desktop"><Table data={address}/></div>
                                <Row className="address-inner-row">
                                    <Col xs={12} md={12} className="over">
                                        <div className="address-inner-block">
                                            <Row between={"xs"}>
                                                <h2 className="address-title">Crypto</h2>
                                                <h2 className="address-title">Issuer</h2>
                                            </Row>
                                            <Table data={crypto}/>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={12} md={4} className="desktop">
                            <div className="address-block address-qr">
                                <QRCode value={this.state.address.account_id} size={240} />
                            </div>
                        </Col>
                        <div className="address-payments">{payments}</div>
                    </Row>
                }
                {this.state.error != null &&
                    <Error message={this.state.error}/>
                }
            </Grid>
        );
    }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/Address/Address.js